import React from 'react';
import { useSelector } from 'react-redux';
import Character from './Character/Character';
import Dialogue from './Dialogue/Dialogue';

import { CharacterStates } from '../../utils/constants';
import { findBaseResource } from '../../utils/slide';

// Ducks
import { RootState } from '../../ducks/configureStore';

import './InstructionalPanel.scss';

interface IProps {
  supplementalDoc?: SupplementalDoc;
  panelIds?: string[];
  layoutIsHorizontal: boolean;
  windowSize: string;
}

const InstructionalPanel = ({
  supplementalDoc,
  panelIds,
  layoutIsHorizontal,
  windowSize,
}: IProps) => {
  // REDUX STATE
  const { file, dialogue } = useSelector((state: RootState) => {
    const { slidesLitmos, quizLitmos } = state;
    const { stateType, tries: quizTries = 0 } = quizLitmos;
    const { currentSlide } = slidesLitmos;
    const { timeline, tries: triesAllowed, learnerData } = currentSlide || {};
    const { correct, completed } = learnerData || {};
    // Get panel Id
    // TODO - Further customize order when LMS options are in place.
    const instructionalPanelId = panelIds?.[0];
    const filteredTimeline = timeline?.filter(
      (resource) => resource.panelId === instructionalPanelId,
    );
    const resource = findBaseResource(filteredTimeline || []) || {};

    // CHARACTER IMAGE
    const resourceType = stateType || CharacterStates.Neutral;
    const file = resource.files?.find((f) => f.type === resourceType);

    // CHARACTER DIALOGUE
    const { initialGreeting, tryAgain, includeInitial } = resource;
    let dialogue = initialGreeting;
    const correctOnFirstTry = completed && quizTries === 1 && correct;
    if ((triesAllowed || 0) > 1 && tryAgain && quizTries > 0 && !correctOnFirstTry) {
      if (includeInitial) {
        dialogue += ` ${tryAgain}`;
      } else {
        dialogue = tryAgain;
      }
    }

    return {
      file,
      dialogue,
    };
  });

  return (
    <div className="InstructionalPanel">
      <Character file={file} windowSize={windowSize} />
      <Dialogue dialogue={dialogue} windowSize={windowSize} />
    </div>
  );
};

export default InstructionalPanel;
